module.exports = __webpack_public_path__ + "static/img/w_05_m.da45bfed.jpg";